import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { Button } from './Button';
import { ProductName } from './ProductName';
import { checkoutUrl, trackCheckout } from '../utils/checkout';
import { mainMockup } from '../data/media';
import { volumes } from '../data/volumes';
import { bonuses } from '../data/bonuses';
const frictionPoints = ['Searching for class ideas', 'Building demonstrations from scratch', 'Reusing the same activities', 'Creating assessments manually', 'Looking through scattered resources', 'Trying to organize techniques yourself'];
const pillars = [{
  value: '6',
  label: 'Volumes'
}, {
  value: '150',
  label: 'Ready-to-teach lessons'
}, {
  value: '5',
  label: 'Free bonus guides'
}, {
  value: '100%',
  label: 'Visual'
}];
const extras = ['Immediate Access', 'Ready-to-Use PDF Format', '7-Day Guarantee'];
export function FinalCTA() {
  return <>
      <section className="bg-blush px-4 py-20 sm:py-28" data-id="element-73" data-mp="zxegyb7de470">
        <div className="mx-auto max-w-4xl text-center" data-id="element-74" data-mp="zuilctizvrlq">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-75" data-mp="2c5y8jjmcybbs">
            Your Next Pastry Class
          </h2>
          <p className="mt-6 text-lg text-cocoa" data-id="element-76" data-mp="2m2udjfd1sfbl">Next week you can keep:</p>
          <ul className="mx-auto mt-6 grid max-w-2xl gap-3 text-left sm:grid-cols-2" data-id="element-77" data-mp="2m4xaykgj5aqc">
            {frictionPoints.map(point => <li key={point} className="flex gap-3 rounded-xl border border-blush-line bg-cream-light px-4 py-3 text-sm leading-6 text-cocoa" data-id="element-78" data-mp="2v428bngcuy0x">
                <span className="text-champagne-deep" aria-hidden="true" data-id="element-79" data-mp="34tlt4ynmp1yf">
                  ✦
                </span>
                {point}
              </li>)}
          </ul>
          <p className="mt-10 font-serif text-2xl italic text-cocoa" data-id="element-80" data-mp="3eri1jip6lisu">Or...</p>
          <p className="mx-auto mt-2 max-w-3xl font-serif text-4xl font-semibold leading-tight text-raspberry sm:text-5xl" data-id="element-81" data-mp="3epf104qek79v">
            You Can Open One Complete System and Start Teaching
          </p>
          <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-y-8 border-y border-champagne py-8 sm:grid-cols-4" data-id="element-82" data-mp="1jm8y0730cl1j">
            {pillars.map(pillar => <div key={pillar.label} className="flex flex-col-reverse" data-id="element-83" data-mp="1shou6ur8jcaa">
                <dt className="mt-1 text-xs font-bold uppercase tracking-[0.12em] text-cocoa" data-id="element-84" data-mp="1npey0wzj1fzk">
                  {pillar.label}
                </dt>
                <dd className="font-serif text-5xl font-semibold text-espresso" data-id="element-85" data-mp="22d032wfyppa4">
                  {pillar.value}
                </dd>
              </div>)}
          </dl>
          <p className="mx-auto mt-10 max-w-2xl text-base leading-7 text-cocoa" data-id="element-86" data-mp="2be825gqayu59">
            Pastry Instructor Ready does not replace your experience as an
            instructor. It gives you the structure, visual resources and
            ready-to-use material that allow you to spend less time planning and
            more time teaching.
          </p>
        </div>
      </section>

      <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-87" data-mp="2x10bi6fnu4j">
        <div className="mx-auto max-w-4xl rounded-3xl border border-champagne bg-cream-light p-7 shadow-xl sm:p-11" data-id="element-88" data-mp="6xjuvjzpneaf">
          <h2 className="text-center font-serif text-4xl font-semibold text-espresso" data-id="element-89" data-mp="3pc2kb23ymzvl">
            Everything That Is Included
          </h2>
          <div className="mt-8 grid gap-x-8 gap-y-4 md:grid-cols-2" data-id="element-90" data-mp="3u92rxhggkaot">
            {volumes.map(volume => <div key={volume.number} className="flex gap-3" data-id="element-91" data-mp="3fc1xh66vu1mn">
                <BookOpenIcon size={18} className="mt-0.5 shrink-0 text-champagne-deep" aria-hidden="true" data-id="element-92" data-mp="3kdiw0v1w9c02" />
                <p className="text-sm leading-6 text-cocoa" data-id="element-93" data-mp="3bb9ma7eg9mnq">
                  <strong className="font-semibold text-espresso" data-id="element-94" data-mp="3bdvv0ad2u87j">
                    {volume.number}
                  </strong>{' '}
                  — {volume.title}
                </p>
              </div>)}
            {bonuses.map(bonus => <div key={bonus.id} className="flex gap-3" data-id="element-95" data-mp="35mi3cgr4oz4k">
                <GiftIcon size={18} className="mt-0.5 shrink-0 text-champagne-deep" aria-hidden="true" data-id="element-96" data-mp="30ogipre20rqz" />
                <p className="text-sm leading-6 text-cocoa" data-id="element-97" data-mp="2vrgelm0rlz2i">
                  <strong className="font-semibold text-raspberry" data-id="element-98" data-mp="2rmqjw0hueqj6">
                    Bonus {bonus.id}
                  </strong>{' '}
                  — {bonus.title}
                </p>
              </div>)}
          </div>
          <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 border-y border-champagne bg-blush px-6 py-4 text-sm font-semibold text-espresso" data-id="element-99" data-mp="2hvvwgssv1kw5">
            {extras.map(item => <li key={item} className="flex items-center gap-2" data-id="element-100" data-mp="27xpvcdevoisc">
                <CheckIcon size={16} className="text-forest" aria-hidden="true" data-id="element-101" data-mp="23ww6nhtm2zye" />
                {item}
              </li>)}
          </ul>
          <div className="mt-10 text-center" data-id="element-102" data-mp="egskf5240w0n">
            <ProductName as="p" className="text-3xl sm:text-4xl" data-id="element-103" data-mp="jfnb0t6bjovb" />
            <p className="mx-auto mt-3 max-w-xl text-base font-semibold leading-7 text-espresso" data-id="element-104" data-mp="jhzr10sinp5q">
              The Complete <span className="text-raspberry" data-id="element-105" data-mp="sguw29jtqt7g">6-in-1</span> Visual
              Teaching System with{' '}
              <span className="text-raspberry" data-id="element-106" data-mp="3rw8clowmffoe">150 Ready-to-Teach</span> Pastry
              Lessons
            </p>
            <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-cocoa" data-id="element-107" data-mp="3vx1xsaioigdl">
              Plan less. Teach with more structure. Make every class easier to
              prepare, explain and deliver.
            </p>
            <img src={mainMockup} alt="Pastry Instructor Ready complete teaching system" loading="lazy" className="mx-auto mt-8 w-full max-w-xl drop-shadow-xl" data-id="element-108" data-mp="9j0pe2664ts8" />
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="mt-8" data-id="element-109" data-mp="3d594eezp6t5c">
              GET PASTRY INSTRUCTOR READY NOW
            </Button>
            <p className="mt-4 text-xs font-medium text-cocoa sm:text-sm" data-id="element-110" data-mp="t4nogxbg2sum">
              Immediate Access · Secure Payment · One-Time Payment
            </p>
          </div>
        </div>
      </section>
    </>;
}